export default __webpack_public_path__ + "static/media/mats-generic-map.54e143e5.gif";